import { Component, ViewChild, inject } from '@angular/core';
import { CmProAuthService } from '@app/core/services/cmpro-auth.service';
import { ConfirmDialogComponent, ConfirmDialogOptions } from '@app/cp/shared/components/confirm-dialog/confirm-dialog.component';
import { CPDialogResult } from '@app/cp/shared/enums/CPDialogResult';
import { ConfirmOutput } from '@app/cp/shared/models/ConfirmOutput';
import { SharedComponentsModule } from '@app/cp/shared/sharedComponents.module';
import { environment } from '../../../../environments/environment';
import { ButtonComponent } from "@progress/kendo-angular-buttons";

@Component({
  selector: 'cp-logout',
  standalone: true,
    imports: [ SharedComponentsModule, ButtonComponent ],
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss'],
})
export class LogoutComponent {
  private cmProAuthService = inject(CmProAuthService);
  @ViewChild('logoutConfirmDialog') private logoutConfirmDialog: ConfirmDialogComponent;

  showPopup(): void {
    const options = new ConfirmDialogOptions();
    options.title = 'Sign Out';
    options.message = `Sign out ${this.cmProAuthService.user?.username ?? ''}?`;
    options.okButtonText = 'Sign Out';
    options.cancelButtonText = 'Cancel';
    this.logoutConfirmDialog.showWithOverrides(options);
  }

  confirmLogout(data: ConfirmOutput): void {
    if (data.dialogResult !== CPDialogResult.ok) {
      return;
    }

    this.cmProAuthService
      .logout({ postLogoutRedirectUri: environment.authConfig.configuration.postLogoutRedirectUri })
      .subscribe();
  }
}
